// src/pages/Home.js
import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import './Home.css';
import heroImage from '../assets/programador.jpg';
import logo from '../assets/ICONO-SF.png';
import { Helmet } from 'react-helmet';

// Íconos reales para "¿Qué hacemos?"
import { FaCode, FaMobileAlt, FaServer, FaShieldAlt, FaShoppingCart, FaCogs } from 'react-icons/fa';

function Home() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  const [formData, setFormData] = useState({
    nombreApellido: '',
    email: '',
    telefono: '',
    empresa: '',
    mensaje: '',
    responseMessage: ''
  });

  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return; // evita dobles clics
    setSubmitting(true);
    try {
      const response = await fetch('/send-email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          nombreApellido: formData.nombreApellido,
          email: formData.email,
          telefono: formData.telefono,
          empresa: formData.empresa,
          mensaje: formData.mensaje
        })
      });
      const responseData = await response.json();
      if (responseData.success) {
                // 🔹 Dispara conversión SOLO si el envío fue exitoso
                if (window.gtag) {
                  window.gtag('event', 'conversion', {
                    send_to: 'AW-17487133304/OBaFCJvTz6obEPj0wZJB',
                    // Opcional:
                    // value: 1.0,
                    // currency: 'ARS',
                    // event_callback: () => { console.log('Conversion enviada'); }
                  });
                }
        setFormData({
          nombreApellido: '',
          email: '',
          telefono: '',
          empresa: '',
          mensaje: '',
          responseMessage: '¡Gracias por contactarnos! A la brevedad nos comunicaremos con usted.'
        });
        setTimeout(() => {
          setFormData(prev => ({ ...prev, responseMessage: '' }));
        }, 5000);
      } else {
        throw new Error(responseData.message);
      }
    } catch (error) {
      setFormData(prev => ({
        ...prev,
        responseMessage: 'Error al enviar el mensaje. Por favor, intente nuevamente.'
      }));
      setTimeout(() => {
        setFormData(prev => ({ ...prev, responseMessage: '' }));
      }, 5000);
        } finally {
          setSubmitting(false);
        }
  };

  return (
    <div className="home-container">
      <Helmet>
        <html lang="es-AR" />
        <title>Compañía de Software en Paraná | Desarrollo a medida | CustomSoft Solutions</title>
        <meta name="description" content="Empresa de desarrollo de software en Paraná, Entre Ríos. Sistemas web, móviles y backend a medida. Consultanos por tu proyecto." />
        <link rel="canonical" href="https://customsoft-solutions.com.ar/" />
      </Helmet>

      {/* Hero */}
      <div className="hero" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="hero-text">
          <h1>Desarrollo de Software a medida para tu negocio</h1>
          <p>Diseñamos soluciones digitales innovadoras a medida para tu empresa</p>
          <a href="#contact-section" className="cta-btn">Solicitá tu presupuesto</a>
        </div>
      </div>

      {/* ¿Qué hacemos? */}
      <section className="intro-band" aria-label="Qué hacemos">
        <div className="intro-section" data-aos="fade-up">
          <h2>¿Qué hacemos?</h2>
          <p className="intro-lead">
            Desarrollamos sistemas a medida para empresas de Entre Ríos y todo el país.
            Web, móvil e integraciones backend con foco en calidad, seguridad y resultados.
          </p>

          <div className="features-grid" role="list">
            <article className="feature-card" role="listitem" data-aos="zoom-in">
              <div className="feature-icon"><FaCode /></div>
              <h3>Web Apps</h3>
              <p>Sitios y aplicaciones SPA con React/Angular, rápidas, escalables y mantenibles.</p>
            </article>

            <article className="feature-card" role="listitem" data-aos="zoom-in" data-aos-delay="50">
              <div className="feature-icon"><FaMobileAlt /></div>
              <h3>Apps Móviles</h3>
              <p>Soluciones móviles y PWA, listas para tienda o uso interno.</p>
            </article>

            <article className="feature-card" role="listitem" data-aos="zoom-in" data-aos-delay="100">
              <div className="feature-icon"><FaServer /></div>
              <h3>Backend & APIs</h3>
              <p>APIs seguras con Java Spring Boot y Node.js, integraciones con terceros.</p>
            </article>

            <article className="feature-card" role="listitem" data-aos="zoom-in" data-aos-delay="150">
              <div className="feature-icon"><FaShieldAlt /></div>
              <h3>Seguridad</h3>
              <p>Autenticación, autorización, cifrado y buenas prácticas OWASP.</p>
            </article>

            <article className="feature-card" role="listitem" data-aos="zoom-in" data-aos-delay="200">
              <div className="feature-icon"><FaShoppingCart /></div>
              <h3>E-commerce</h3>
              <p>Tiendas multiempresa, gestión de catálogo, pedidos y pagos.</p>
            </article>

            <article className="feature-card" role="listitem" data-aos="zoom-in" data-aos-delay="250">
              <div className="feature-icon"><FaCogs /></div>
              <h3>Automatización</h3>
              <p>Procesos, reportes y bots para optimizar tareas y reducir costos.</p>
            </article>
          </div>
        </div>
      </section>

      {/* Servicios */}
      <section id="servicios-section" className="services-section" data-aos="fade-up">
          <h2>Nuestros Servicios</h2>

          <div className="services-grid-cards">
            <article className="service-card" data-aos="zoom-in">
              <div className="service-icon">
                {/* FaCode */}
                <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                  <path d="M9.4 16.6 5.8 13l3.6-3.6L8 8 3 13l5 5 1.4-1.4Zm5.2 0L18.2 13l-3.6-3.6L16 8l5 5-5 5-1.4-1.4Z"/>
                </svg>
              </div>
              <h3>Software a Demanda</h3>
              <p>Aplicaciones web a medida con React/Angular/Node, alta performance y foco en UX.</p>
            </article>

            <article className="service-card" data-aos="zoom-in" data-aos-delay="60">
              <div className="service-icon">
                {/* FaShieldAlt */}
                <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                  <path d="M12 2 4 5v6c0 5 3.4 9.7 8 11 4.6-1.3 8-6 8-11V5l-8-3Zm0 2.2 6 2.2v4.6c0 4-2.6 7.9-6 9.1-3.4-1.2-6-5.1-6-9.1V6.4l6-2.2Zm0 4.3a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z"/>
                </svg>
              </div>
              <h3>Desarrollo Seguro</h3>
              <p>OAuth2/JWT, OWASP y buenas prácticas para proteger datos y transacciones.</p>
            </article>

            <article className="service-card" data-aos="zoom-in" data-aos-delay="120">
              <div className="service-icon">
                {/* FaMobileAlt */}
                <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                  <path d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Zm0 2v16h10V4H7Zm4 14h2v2h-2v-2Z"/>
                </svg>
              </div>
              <h3>Aplicaciones Móviles</h3>
              <p>Apps nativas y PWA, listas para store o uso interno según tu necesidad.</p>
            </article>

            <article className="service-card" data-aos="zoom-in" data-aos-delay="180">
              <div className="service-icon">
                {/* FaLifeRing */}
                <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                  <path d="M12 2a10 10 0 1 0 .001 20.001A10 10 0 0 0 12 2Zm6.9 8h-3.1a3.9 3.9 0 0 0-1.8-1.8V5.1a8.1 8.1 0 0 1 4.9 4.9ZM10 6.1V8a3.9 3.9 0 0 0-1.8 1.8H5.1a8.1 8.1 0 0 1 4.9-4.9ZM6.1 14h2a3.9 3.9 0 0 0 1.9 1.9v2a8.1 8.1 0 0 1-4.9-3.9Zm9.9 0h1.9a8.1 8.1 0 0 1-4.9 3.9v-2A3.9 3.9 0 0 0 16 14Zm-4-5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"/>
                </svg>
              </div>
              <h3>Soporte y Mantenimiento</h3>
              <p>Monitoreo, actualizaciones y acompañamiento continuo para máxima estabilidad.</p>
            </article>
          </div>
        </section>


      {/* Diferenciales */}
      <section className="why-section" data-aos="fade-up">
        <h2>¿Por qué elegirnos?</h2>
        <ul className="why-list">
          <li>✅ Desarrollo 100% a medida</li>
          <li>✅ Seguridad y buenas prácticas</li>
          <li>✅ Soporte post-implementación</li>
          <li>✅ Cumplimiento de plazos</li>
        </ul>
      </section>

      {/* Tecnologías */}
      <section className="technologies-section" data-aos="fade-up">
        <h2>Tecnologías en las que trabajamos</h2>
        <div className="technologies-grid">
          <div className="tech-card">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg" alt="React" className="tech-logo" />
            React
          </div>
          <div className="tech-card" data-aos="fade-up">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/angularjs/angularjs-original.svg" alt="Angular" className="tech-logo" />
            Angular
          </div>
          <div className="tech-card" data-aos="fade-up">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg" alt="JavaScript" className="tech-logo" />
            JavaScript
          </div>
          <div className="tech-card" data-aos="fade-up">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg" alt="Java" className="tech-logo" />
            Java
          </div>
          <div className="tech-card" data-aos="fade-up">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/android/android-original.svg" alt="Android" className="tech-logo" />
            Android
          </div>
          <div className="tech-card" data-aos="fade-up">
            <img src="https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg" alt="Node JS" className="tech-logo" />
            Node JS
          </div>
        </div>
      </section>

      {/* Contacto */}
      <section id="contact-section" className="contact-section" data-aos="fade-up">
        <h2>CONTACTANOS PARA TU NUEVO PROYECTO</h2>
        <p>¿Cómo podemos ayudarte?</p>
        <form className="contact-form" onSubmit={handleSubmit}>
          <input type="text" name="nombreApellido" placeholder="Nombre y Apellido" value={formData.nombreApellido} onChange={handleChange} required />
          <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
          <input type="tel" name="telefono" placeholder="Teléfono" value={formData.telefono || ''} onChange={handleChange} required />
          <input type="text" name="empresa" placeholder="Empresa/Proyecto" value={formData.empresa} onChange={handleChange} required />
          <textarea name="mensaje" placeholder="Mensaje" rows="4" value={formData.mensaje} onChange={handleChange} required></textarea>
          <button type="submit" 
                className="cta-btn" 
                disabled={submitting}
                aria-busy={submitting}>
               {submitting ? 'Enviando…' : 'Solicitá tu presupuesto gratuito'}
          </button>
          {formData.responseMessage && (
            <p className={`form-message ${formData.responseMessage.includes('Gracias') ? 'success' : 'error'}`}>
              {formData.responseMessage}
            </p>
          )}
        </form>
      </section>
    </div>
  );
}

export default Home;
